<template>
<b-notification class="box" type="is-info" :closable="false">
  <div v-if="!state">
    <form @submit.prevent="submit()" :disabled="!canSubmit">
      <div class="content" v-html="message"></div>
      <b-field>
        <b-input id="email" type="email" required
                 placeholder="email address"
                 v-model.trim="email"></b-input>
      </b-field>
      <b-field>
        <b-input type="password" required
                 placeholder="password"
                 v-model="password"></b-input>
      </b-field>
      <b-field>
      <div class="level">
        <div class="level-left">
          <span class="button is-info" v-if="emailIsValid" @click="requestReset">
            *request password reset
          </span>
        </div>
        <div class="level-right">        
          <button class="button" :class="{'is-primary':emailIsValid && passwordIsValid}"
                  v-if="!haveRequestedReset"
                  :disabled="!canSubmit"> 
            <b-icon :icon="$store.state.authState=='authenticating'?'coffee':'account'"> </b-icon>
            {{signintext}}
          </button>
        </div>
      </div>
      </b-field>
      <b-notification v-if="canSubmit && haveSubmitted && $store.state.authState=='error'"
                      class="box is-error" type="is-danger" has-icon :closable="false">
        {{$store.state.authError}}
      </b-notification>
      <b-notification v-if="haveRequestedReset"
                      class="box is-warning" type="is-warning" has-icon :closable="false">
        {{haveRequestedReset}}
      </b-notification>
    </form>
  </div>
</b-notification>
</template>

<script>
import Firebase from '../firebase.js'

export default {
  name: 'SignupCard',
  data () {
    return {
      state: undefined,
      email: '',
      password: '',
      emailIsValid: false,
      haveSubmitted: false,
      haveRequestedReset: false,
    }
  },
  props: {
    message: {type: String, required: true},
  },
  computed: {
    canSubmit: function() {
      return this.emailIsValid && this.passwordIsValid && this.$store.state.authState!='authenticating'
    },
    signintext: function () {
      var providers = this.$store.state.signinProviders
      if (!this.emailIsValid) {
        return 'valid email address required'
      }
      if (!this.passwordIsValid) {
        return 'password required, minimum 6 characters'
      }
      return 'Sign In/Up'

      for (var i=0; i<providers.length; ++i) {
        switch (providers[i]) {
        case 'none': return 'Sign Up'
        case 'password': return 'Sign In'
        }
      }
      return ''
    },
    passwordIsValid: function() {
      return this.password && this.password.length >= 6
    },
  },
  methods: {
    submit() {
      this.$store.dispatch('registerOrSignIn',
                           { email: this.email, password: this.password })
      this.haveSubmitted = true
    },
    requestReset() {
      console.log("password reset requested")
      Firebase.auth.sendPasswordResetEmail(this.email).then(() => {
        this.haveRequestedReset = 'Password reset email has been sent. Please check your inbox.'
      }).catch(err => {
        this.haveRequestedReset = 'Password reset failed - is your email correct?'
      })
    },
  },
  watch: {
    email() {
      if (this.$el) {
        const el = this.$el.querySelector('#email')
        this.emailIsValid = el && el.checkValidity()
      }
      if (this.emailIsValid) {
        console.log('valid email....',  this.email)
        //this.$store.dispatch('fetchProvidersForEmail', this.email)
      } else {
        console.log('bad email....',  this.email)
      }
    },
    password() {
      this.haveRequestedReset = false
    },
    canSubmit(newVal) {
      console.log('!!canSubmit:', newVal)
      if (!newVal) {
        this.haveSubmitted = false
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SignupCard.vue